import { render, staticRenderFns } from "./EngineeringBranchesAdd.vue?vue&type=template&id=e98d1818&"
import script from "./EngineeringBranchesAdd.vue?vue&type=script&lang=js&"
export * from "./EngineeringBranchesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports